import React from "react";
import {isNotEmpty} from "@Array/isNotEmpty";
import SuggestedDates from "@RouteSuggestions/features/suggestedDates/components/SuggestedDates";
import ParamsType from "@SearchResults/types/params/Params.type";
import SuggestionsDataType from "@SearchResults/types/suggestions/SuggestionsData.type";
import useSingleConfirmedRoute from "@Route/hooks/useSingleConfirmedRoute";
import useGbtBanner from "@/pages/searchResults/features/banners/features/getByTransferBanner/hooks/useGbtBanner";
import GetByTransferNoResultsNotification from "@/pages/searchResults/features/banners/features/getByTransferBanner/components/GetByTransferNoResultsNotification";
import { GetByFerryDataType } from "@/pages/searchResults/features/banners/features/getByTransferBanner/types/GetByFerryData.type";
import { TransfersDataType } from "@/pages/searchResults/features/banners/features/getByTransferBanner/types/TransfersData.type";
import { defaultVehicleData } from "@/features/getByTransfer/constants/defaultVehicleData";
import useDefaultVehicleSnippets from "@/features/getByTransfer/features/snippets/hooks/useDefaultVehicleSnippets";

interface RouteSuggestionsProps {
    suggestionData: SuggestionsDataType,
    params: ParamsType,
    hasRoutesOnSelectedDate?: boolean,
}

function RouteOtherDatesSuggestions({suggestionData, params, hasRoutesOnSelectedDate = false}: RouteSuggestionsProps) {
    const isSingleRouteConfirmed = useSingleConfirmedRoute()

    if (suggestionData && isNotEmpty(suggestionData?.dates)) {
        return (
            <SuggestedDates
                dates={suggestionData.dates}
                isReturn={params.isReturn}
                searchedDate={isSingleRouteConfirmed ? params.returnDate : params.date}
                hasRoutesOnSelectedDate={hasRoutesOnSelectedDate}
            />
        )
    }

    return null
}

export default RouteOtherDatesSuggestions
